import React from 'react'
import _ from 'lodash'
import { VictoryArea, VictoryLine, VictoryGroup, VictoryChart, VictoryTheme, VictoryLabel, VictoryTooltip, VictoryAxis } from 'victory';

function getUpdateDate(timeStampDate) {
  const date = new Date(parseInt(timeStampDate))
  return `${date.getUTCFullYear().toString().slice(-2)}/${date.getMonth() + 1 }/${date.getDate()}\n ${date.getHours()}:${date.getMinutes()}`
 }

const grapht = (props) => {
  var data = []
  var domain = props.domain
  var mediad = props.media ? props.media : 190
  var media = []
   if(_.isEmpty(props)) {
     data = [{Control: 'C 0', pa:0}, {Control: 'C 1', pa: 0}]
     media = [{month: "C 0", media: 120},{month: "C 1", media: 120},{month: "C 2", media: 120},{month: "C 3", media: 120},{month: "C 4", media: 120}]
   } else {
     if(props.data){
       data = []

       var arr = _.orderBy(props.data, ['timestamp'], ['asc']);

       arr.map(( e, i )=> {
          data.push({Control: getUpdateDate(e.timestamp), pa: e[props.index]}) 
          media.push({month: getUpdateDate(e.timestamp), media: mediad})
       })

     }


   }

  return (
        <VictoryChart domainPadding={2}>
          <VictoryLine
            labelComponent={<VictoryTooltip/>}
            eventKey={(datum) => datum.Control}
            style={{
              data: {stroke: "rgba(58,168,235,0.9)"},
              labels: {fontSize: 10,fill: 'white'}
            }}
            data={data}
            x="Control"
            y={(datum) => datum.pa}
          />

          <VictoryLine
          data={media}
          style={{
            data: {stroke: "yellow", 'stroke-dasharray': [5, 5]},
            labels: {fontSize: 10, fill: 'white'},
            parent: {border: "1px dotted white"}
          }}
          x="month"
          y={(datum) => datum.media}
          />

          <VictoryAxis 
            dependentAxis
            domain= {domain}
            style={{
              axis: {stroke: "rgba(250,250,250,1)"},
              axisLabel: {fontSize: 10, fill: 'white'},
              ticks: {stroke: 'white'},
              tickLabels: {
                fill: 'white'
              }
            }}
          />

          <VictoryAxis
          style={{
            axis: {stroke: "rgba(250,250,250,1)"},
            axisLabel: {fontSize: 10, fill: 'white'},
            ticks: {stroke: 'white'},
            tickLabels: {
              fill: 'white'
            }
          }}

        />
      </VictoryChart>
  )
}
export default (props) => {
  return <g>{grapht(props)}</g>
}



// WEBPACK FOOTER //
// ./src/components/ViewStatics/ViewStatics.js